const Projects = () => {

    return(
        <div>
            <h1 className="text-[5rem] text-red-800">Projects</h1>
        </div>
    )
}

export default Projects;